import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { SessionService } from '@core/services/session.service';
import {
  CoinflipSkinItem,
  CoinflipWon,
} from '@features/games/coinflip/interfaces/coinflip.interface';
import { SkinsListComponent } from '@core/components/skins-list/skins-list.component';
import { CoinflipSide } from '@features/games/coinflip/interfaces/coinflip.interface';
import { BalanceIconComponent } from '@core/components/balance-icon/balance-icon.component';
import { DecimalPipe } from '@angular/common';
import { PlayerRowComponent } from '@core/components/player-row/player-row.component';
import { ContextMenuService } from '@core/services/context-menu.service';
import { ClipboardService } from '@core/services/clipboard.service';
import { isMenuless } from '@core/utils/bot-player.util';

@Component({
  selector: 'app-coinflip-skins-modal',
  imports: [
    SkinsListComponent,
    BalanceIconComponent,
    DecimalPipe,
    PlayerRowComponent,
  ],
  templateUrl: './coinflip-skins-modal.component.html',
  styleUrl: './coinflip-skins-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class CoinflipSkinsModalComponent {
  public contextMenuService = inject(ContextMenuService);
  public clipboardService = inject(ClipboardService);
  protected readonly isMenuless = isMenuless;

  readonly coinflipGame = input.required<CoinflipWon>();
  readonly skins = input.required<CoinflipSkinItem[]>();
  readonly coinflipSide = input.required<CoinflipSide>();

  skinsPrice = computed(() => {
    return this.skins().reduce((acc, skin) => acc + skin.price, 0);
  });

  public sessionService = inject(SessionService);
}
